import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountNameQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetAccountNameQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
};

export const GetAccountNameDocument = gql`
  query getAccountName($accountId: String!) {
    account(accountId: $accountId) {
      id
      tradingName
    }
  }
`;
